// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"44737484","453":"94781b46"}[chunkId] + ".chunk.js";
};